import type { AdminMemberProfile } from "@/lib/admin-member-profile-api"

import { Card, CardContent } from "@/components/ui/card"

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const

type ActivityPointsCardProps = {
  activityPoints: AdminMemberProfile["activityPoints"] | undefined
  isError: boolean
  isLoading: boolean
}

export function ActivityPointsCard({
  activityPoints,
  isError,
  isLoading,
}: ActivityPointsCardProps) {
  return (
    <Card>
      <CardContent className="space-y-3">
        <h2 className="text-lg font-semibold">Activity Points</h2>
        {isLoading ? (
          <p className="text-sm text-muted-foreground">
            Loading activity points...
          </p>
        ) : isError || !activityPoints ? (
          <p className="text-sm text-muted-foreground">
            Activity points unavailable
          </p>
        ) : activityPoints.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            No activity points recorded
          </p>
        ) : (
          <ul className="divide-y">
            {activityPoints.map(({ year, month, points }) => (
              <li
                key={`${year}-${month}`}
                className="flex items-center justify-between gap-4 py-2 text-sm"
              >
                <span>
                  {MONTH_NAMES[month - 1]} {year}
                </span>
                <span className="font-medium">{points}</span>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  )
}
